
import * as React from "react";
import {Tabs} from "shared/controls/Tabs/Tabs";

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faThList} from "@fortawesome/free-solid-svg-icons/faThList";
import {library} from "@fortawesome/fontawesome-svg-core";
import {faCog} from "@fortawesome/free-solid-svg-icons/faCog";
import {FieldsTab} from "./tabs/FieldsTab/FieldsTab";
import {EventManager} from "shared/utilities/Events/EventManager";
import {OpenProperties} from "../Events/OpenProperties";
import {IObservableValue, observable} from "mobx";
import {observer} from "mobx-react";
import {FieldSettings} from "./tabs/FieldSettings/FieldSettings";

import {StylesTab} from "./tabs/Styles/StylesTab";
import {faPalette} from "@fortawesome/free-solid-svg-icons/faPalette";
import {ShowGroupOptions} from "../Events/ShowGroupOptions";
import {SwitchContainer} from "shared/controls/animation/SwitchContainer";
import {GroupPanel} from "./Panels/GroupPanel";
import {Dialog} from "shared/controls/Dialogs/core/Dialog";
import {FormPicker} from "./Dialogs/FormPicker";
import {UpdateProperties} from "InternalShared/Events/UpdateProperties";
import {PDFControlBase} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase";
import {PropertyBase} from "InternalShared/PageBuilder/Controls/Properties/PropertyBase";
import {PDFDocument} from "PageBuilder/pagebuilder/PDFDocument";
import {FieldDragStarted} from "InternalShared/Events/FieldDragStarted";
import {FieldDragEnded} from "InternalShared/Events/FieldDragEnded";




library.add(faThList);
library.add(faCog);
library.add(faPalette);
@observer
export class Builder extends React.Component<BuilderProp,BuilderState>{
    public page:PDFDocument;
    private scrollTimeOut:any;
    private $builder:JQuery;
    private $toolbar;
    public builderElement:any;
    @observable
    public TabsToOpen:IObservableValue<string>;
    public FieldSettings:FieldSettings;
    public StylesTab:StylesTab;

    constructor(prop:any,context:any)
    {
        super(prop,context);
        this.TabsToOpen=observable.box('');
        this.state={
            IsDragging:false,
            ShowGroupPanel:false
        };

        EventManager.Subscribe(OpenProperties,item=>this.OpenProperties(item.Item));
        EventManager.Subscribe(UpdateProperties,item=>this.UpdateProperties(item.properties));
        EventManager.Subscribe(FieldDragStarted,e=>{
           this.setState({
               IsDragging:true
           })
        });

        EventManager.Subscribe(FieldDragEnded,e=>{
           this.setState({
               IsDragging:false
           })
        });


        EventManager.Subscribe(ShowGroupOptions,()=>this.ShowGroupPanel())
    }


    componentDidMount(){
        //this.$toolbar=this.toolbar.$container;
        this.$builder=jQuery(this.builderElement);
        jQuery(document).scroll(event=>this.OnScroll(event));
        //this.$toolbar=this.$builder.find('.pdfToolBar');

    }

    render(){
        return(
            <div ref={(e)=>this.builderElement=e} className="pdfBuilder" style={{backgroundColor:'#eaeaea',border:'solid #afafaf 1px', position:'relative',height:'calc(100% - 70px)'}}>
                <div style={{width:500,display:'inline-block',verticalAlign:'top',backgroundColor:'#efefef',height:'100%'}}>
                        {this.state.ShowGroupPanel ?
                            <GroupPanel/>:
                            <Tabs OccupyAvailableSpace={true} styles={{height:'100%'}} key={'test2'} TabToOpen={this.TabsToOpen} ContentHeight={'100%'} disableScrollYOnAnimation={true}>
                                <Tabs.Item Id={'fields'} style={{padding: 0}} Title={"Fields"}
                                           Icon={<FontAwesomeIcon icon={"th-list"}/>}>
                                    <FieldsTab/>
                                </Tabs.Item>
                                <Tabs.Item style={{padding: 0}} Id={'settings'} Title={"Field Settings"}
                                           Icon={<FontAwesomeIcon icon={"cog"}/>}>
                                    <FieldSettings ref={e => this.FieldSettings = e}/>
                                </Tabs.Item>
                                <Tabs.Item style={{padding: 0}} Title={'Styles'}
                                           Icon={<FontAwesomeIcon icon={'palette'}/>}>
                                    <StylesTab ref={e => this.StylesTab = e}/>
                                </Tabs.Item>
                            </Tabs>
                        }

                </div>
                <div style={{ width:'calc(100% - 500px)',display:'inline-block',overflow:'auto',backgroundColor:'#f7f7f9',height:'100%'}}>
                    <PDFDocument IsDragging={this.state.IsDragging} ref={node=>this.page=node}></PDFDocument>
                </div>
            </div>
        )
    }



    private async OpenProperties(Item: PDFControlBase) {
        if(this.state.ShowGroupPanel)
        {
            this.setState({ShowGroupPanel:false},()=>{this.MaybeGoToFieldSettings(Item)});
        }else
            this.MaybeGoToFieldSettings(Item);
    }

    private UpdateProperties(Properties: PropertyBase[]) {

    }

    private OnScroll(event: any) {
        let scrollTop=jQuery(window).scrollTop();
        let scrollLeft=jQuery(window).scrollLeft();
        let builderTop=this.$builder.offset().top;
        let builderLeft=this.$builder.offset().left;


        let newLeft=Math.max(0,scrollLeft-builderLeft);
        let newTop=Math.max(0,scrollTop-builderTop+32);

        this.$toolbar.css('top',newTop);
    }

    load(form:FormDTO,options:any)
    {
        this.page.Initialize(form,options);
    }


    private ShowGroupPanel() {
        this.setState({ShowGroupPanel:true});
    }

    private async MaybeGoToFieldSettings(Item:PDFControlBase) {
        if(this.FieldSettings==null)
            return;
        await this.FieldSettings.FillPanel(Item);
        if(this.StylesTab!=null)
            this.StylesTab.FillPanel(Item);
        if(Item==null)
            this.TabsToOpen.set('fields');
        else
            if(this.TabsToOpen.get()=='fields'||this.TabsToOpen.get()=='')
                this.TabsToOpen.set('settings');


    }

}




interface BuilderProp {

}

interface BuilderState {
    IsDragging:boolean;
    ShowGroupPanel:boolean;
}
